import { render, staticRenderFns } from "./ReplacementFundCitation.vue?vue&type=template&id=b24ff4f6"
import script from "./ReplacementFundCitation.vue?vue&type=script&lang=js"
export * from "./ReplacementFundCitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports